import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Navbar from '../components/navbar/navbar'
import FooterTop from '../components/footer-top'
import Footer from '../components/footer'

import error from '../assets/img/404.png'
import ScrollToTop from '../components/scroll-to-top'

export default function Error() {
  const { t } = useTranslation();

  return (
    <>
    <Navbar transparent={false}/>

    <section className="error-wrap">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-10">
                    <div className="text-center">
                        <img src={error} className="img-fluid" alt={t('error.pageNotFound')}/>
                        <p>{t('error.errorMessage')}</p>
                        <Link className="btn btn-primary px-5" to="/">{t('error.backToHome')}</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <FooterTop bg="theme-bg"/>
    <Footer/>
    <ScrollToTop/>
    </>
  )
}
